var map = {
	"./artifact.svg": 86,
	"./creature.svg": 87,
	"./enchantment.svg": 88,
	"./instant.svg": 89,
	"./land.svg": 90,
	"./mixed.svg": 22,
	"./planeswalker.svg": 91,
	"./sorcery.svg": 92
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/types ./~/svg-inline-loader?removeSVGTagAttrs=true! ^\.\/.*\.svg$
// module id = 146
// module chunks = 0